/**
 * יצירת קישור תשלום סוכן — התאמת endpoint כמו CreditCardDetails (payment agent).
 */

import { getUserInfo } from "../../services/localStorage";
import { resolvePaymentViewerAgentId } from "../../utils/payment/resolvePaymentViewerContext";

/**
 * @param {Record<string, unknown> | null} selectedOrder
 * @param {Record<string, unknown> | null} mergedOrder
 * @returns {string}
 */
export function resolveOperationRequestPaymentEndpoint(selectedOrder, mergedOrder) {
  const raw =
    mergedOrder &&
    typeof mergedOrder === "object" &&
    mergedOrder.raw &&
    typeof mergedOrder.raw === "object" &&
    !Array.isArray(mergedOrder.raw)
      ? mergedOrder.raw
      : {};
  const rawOrderType = String(
    selectedOrder?.rawOrderType ?? selectedOrder?.orderType ?? ""
  ).toLowerCase();
  const dealRaw = String(raw.dealtype ?? raw.deal_type ?? "").trim();
  const dealUpper = dealRaw.toUpperCase();
  const hasCruiseShape =
    dealUpper === "CRUISE" ||
    rawOrderType === "cruise" ||
    !!(raw.cruiseInfo ?? raw.cruise);

  if (hasCruiseShape) return "/getCruisePaymentUrl";
  if (rawOrderType === "dynamic_package") return "/getDynamicPaymentUrl";

  const ldsDeals = new Set([
    "FLIGHTSHOTEL",
    "HOTEL",
    "DYNAMIC",
    "ORGANIZEDTOUR",
    "FLIGHTS",
  ]);
  if (dealUpper && ldsDeals.has(dealUpper)) return "/getLDSPaymentUrl";
  if (raw.dealid != null || rawOrderType === "lds_package") return "/getLDSPaymentUrl";

  return "/getGimmonixPaymentUrl";
}

/**
 * @param {unknown} data
 * @returns {string | null}
 */
export function extractPrimaryPaymentUrlFromAgentPaymentResponse(data) {
  if (!data || typeof data !== "object" || data.status !== "ok" || !data.order) {
    return null;
  }
  const payments = data.order.payments;
  if (!Array.isArray(payments) || payments.length === 0) return null;
  const last = payments[payments.length - 1];
  const u = last?.paymentUrl ?? last?.url ?? last?.payment_url;
  if (u == null) return null;
  const s = String(u).trim();
  return s || null;
}

/**
 * @returns {string | number | null}
 */
export function resolveAgentIdForPaymentBody() {
  return resolvePaymentViewerAgentId(getUserInfo());
}
